import { render, staticRenderFns } from "./LoadingPageWithQuote.vue?vue&type=template&id=b1e2ff36&scoped=true&"
import script from "./LoadingPageWithQuote.vue?vue&type=script&lang=js&"
export * from "./LoadingPageWithQuote.vue?vue&type=script&lang=js&"
import style0 from "./LoadingPageWithQuote.vue?vue&type=style&index=0&id=b1e2ff36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e2ff36",
  null
  
)

export default component.exports